import React from 'react';
import { FavoriteStar } from '~/web-frontend-components/std/UI';
import { Link } from 'react-router-dom';
export const ChamptionshipHeader = React.memo((props) => <tr className={`l-tr l-t-tr-${props.sportID}`}>
      <th className={`l-td l-td-s-${props.sportID} l-s-r-${props.sportID}`} colSpan={20}>
         <div className="l-td-line">
            <FavoriteStar isFavorite={props.isFavorite} onClick={props.onFavorite}/>
            <div className="l-d l-d-line" onClick={props.fold}>
               <div className={`l-t-i-i ${props.isFolded ? 'l-t-i-i-a' : ''}`}>
                  <div className="l-t-i-i-i">
                     <span className="f-s-ico-arrow_buttom_1"/>
                  </div>
               </div>
            </div>
            <Link className="l-th-name" to={props.url}>
               {props.title}
            </Link>
         </div>
      </th>
   </tr>);



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/matches/list/sport/championship/Header.jsx